const mainURL = 'https://api.surtidoradecauchos.com/api/';
//const mainURL = 'http://dev.surtidoradecauchos.com/api/';

export default mainURL;
